import { AuthUser } from 'app/provider/auth'
import { GroupPostCreationModal } from '../group-post-creation-modal'
import { PostCreationView, PostFormData, SubmitPostData } from './post-creation-view'
import { GroupPost } from 'app/types'

export interface GroupPostEditWizardProps {
  open: boolean
  user: Pick<AuthUser, 'id' | 'fullName' | 'avatar' | 'token'>
  post: Pick<GroupPost, 'id' | 'text' | 'image' | 'group'>
  submitting: boolean
  onOpenChange: (value) => void
  onSubmit: (data: SubmitPostData, cb: () => void) => void
}

export const GroupPostEditWizard = (props: GroupPostEditWizardProps) => {
  const defaultValues: PostFormData = {
    text: props.post.text,
    image: props.post.image?.url || null,
  }

  return (
    <GroupPostCreationModal key="Edit modal" open={props.open} onOpenChange={props.onOpenChange}>
      <PostCreationView
        title="Edit post"
        user={props.user}
        onOpenChange={props.onOpenChange}
        onSubmit={props.onSubmit}
        isSubmitting={props.submitting}
        defaultValues={defaultValues}
        selectedGroup={props.post.group}
        onPageChange={() => {}}
        isEditing
      />
    </GroupPostCreationModal>
  )
}
